export default {
	CriteriaSetups(state) {
		return state.CriteriaSetups;
	}
};
